import React from 'react'

import { Checkbox } from '@droidmap/frontend-ui'

export interface ConfirmationDialogFlag {
  id: string
  label: string
  defaultChecked?: boolean
}

export interface ConfirmFlagsInputProps {
  flags: ConfirmationDialogFlag[]
  onChange?: (checked: Record<string, boolean>) => void
}

const ConfirmFlagsInput: React.FC<ConfirmFlagsInputProps> = ({
  flags,
  onChange,
}) => {
  const getInitialChecked = (
    flags: ConfirmationDialogFlag[],
  ): Record<string, boolean> => {
    const initial: Record<string, boolean> = {}
    flags.forEach((flag) => {
      initial[flag.id] = !!flag.defaultChecked
    })
    return initial
  }

  const [checked, setChecked] = React.useState<Record<string, boolean>>(() =>
    getInitialChecked(flags),
  )

  React.useEffect(() => {
    onChange?.(checked)
  }, [checked, onChange])

  // Re-seed during render when the flag set changes, rather than in an effect,
  // which rendered the new flags once against the previous set's checked state.
  const [seededFlags, setSeededFlags] = React.useState(flags)
  if (seededFlags !== flags) {
    setSeededFlags(flags)
    setChecked(getInitialChecked(flags))
  }

  return (
    <div className="flex flex-col gap-2">
      {flags.map((flag) => (
        <Checkbox
          key={flag.id}
          id={flag.id}
          checked={!!checked[flag.id]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setChecked((prev) => ({ ...prev, [flag.id]: e.target.checked }))
          }
          label={flag.label}
        />
      ))}
    </div>
  )
}

export default ConfirmFlagsInput
